<template>
  <div>
    <navbar class="mb-2"></navbar>
    <router-view></router-view>
  </div>
</template>
<script>
import navbar from "./Navbar.vue";
export default {
  components: {
    navbar
  },

  // directives
  // filters

  props: {
    //
  },

  data: () => ({
    //
  }),

  computed: {
    //
  },

  watch: {
    //
  },

  mounted() {
    //
  },

  methods: {
    //
  }
};
</script>

<style></style>
